module.exports = __webpack_public_path__ + "static/media/TN-Women-Skirts.3e26429d.svg";